/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perks_Unit_Replies_ReceivedInputs */



/**
* | output |
* | --- |
* | "replies received" |
*
* @param {Perks_Unit_Replies_ReceivedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_unit_replies_received = /** @type {((inputs?: Perks_Unit_Replies_ReceivedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Unit_Replies_ReceivedInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("полученных ответов")
	return /** @type {LocalizedString} */ ("replies received")
});